<template>
    <div class="grid gap-2">
        <label>
            <input
                v-model="showLabels"
                type="checkbox"
            />
            Show labels next to radio buttons
        </label>

        <form
            class="mb-2 justify-self-start rounded-md border border-dashed border-ds-primary-400 bg-ds-primary-100 p-4"
            @submit.prevent="onSubmit"
        >
            <h3 class="mb-3 text-content-lg font-semibold">Radios</h3>
            <div class="mb-3 grid grid-cols-[auto,auto,auto,auto] items-start gap-4">
                <DsRadio
                    v-model="selectedRadio"
                    :label="label1"
                    name="example"
                    value="one"
                />
                <DsRadio
                    v-model="selectedRadio"
                    :label="label2"
                    name="example"
                    value="two"
                />
                <DsRadio
                    v-model="selectedRadio"
                    :label="label3"
                    name="example"
                    value="three"
                />
                <DsRadio
                    v-model="selectedRadio"
                    :label="label4"
                    name="example"
                    value="four"
                />
            </div>
            <h3 class="mb-3 text-content-lg font-semibold">Disabled Radios</h3>
            <div class="mb-3 grid items-start gap-4">
                <DsRadio
                    v-model="selectedDisabledRadio"
                    disabled
                    :label="label5"
                    name="disabled-radios"
                    value="disabled"
                />
                <DsRadio
                    v-model="selectedDisabledRadio"
                    disabled
                    :label="label6"
                    name="disabled-radios"
                    value="disabled-checked"
                />
            </div>
            <button class="mt-4 rounded-sm bg-ds-gray-900 px-4 py-2 text-white">Submit</button>
        </form>

        <div>
            Selected value: <strong>{{ selectedRadio }}</strong>
        </div>
        <div>
            Submitted value: <strong>{{ submittedVal }}</strong>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsRadio from '@ds/form/input/DsRadio.vue';
import { computed, ref } from 'vue';

const selectedRadio = ref('three');
const selectedDisabledRadio = ref('disabled-checked');
const submittedVal = ref();
const showLabels = ref(true);
const label1 = computed(() => (showLabels.value ? 'One' : ''));
const label2 = computed(() => (showLabels.value ? 'Two' : ''));
const label3 = computed(() => (showLabels.value ? 'Three' : ''));
const label4 = computed(() =>
    showLabels.value
        ? 'Fourem ipsum dolor sit, amet consectetur adipisicing elit. Expedita illum incidunt minima velit doloremque reprehenderit repudiandae ipsum possimus provident error quod repellat eligendi, mollitia molestiae, laudantium necessitatibus quos totam aspernatur. Iste laborum modi accusantium quo nesciunt perferendis fugit? Non, magni!'
        : '',
);
const label5 = computed(() => (showLabels.value ? 'Disabled' : ''));
const label6 = computed(() => (showLabels.value ? 'Disabled and checked' : ''));

const onSubmit = (evt: Event) => {
    const formData = new FormData(evt.target as HTMLFormElement);
    submittedVal.value = formData.get('example');
};
</script>
